import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { createAction, createReducer } from 'redux-act';
import Immutable from 'seamless-immutable';
import i18next from 'i18next';
import { createSelector } from 'reselect';
export var key = 'i18n';

//
// Initial state
//
var initialState = {
  lang: null,
  store: null,
  locales: null,
  configuration: {}
};

//
// Actions
//
export var actions = {
  setLang: createAction('I18n: setLang', function (lang) {
    return {
      lang: lang
    };
  }),
  setLocales: createAction('I18n: setLocales', function (locales) {
    return {
      locales: locales
    };
  }),
  setStore: createAction('I18n: setStore', function (store) {
    return {
      store: store
    };
  }),
  setConfiguration: createAction('I18n: setConfiguration', function (configuration) {
    return {
      configuration: configuration
    };
  }),
  saveLang: createAction('I18n: saveLang', function (lang, store) {
    return {
      lang: lang,
      store: store
    };
  })
};

//
// Reducer
//
export var reducer = createReducer(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, actions.saveLang, function (state, _ref) {
  var lang = _ref.lang,
    store = _ref.store;
  return Immutable["static"].merge(state, {
    lang: lang,
    store: store
  });
}), actions.setStore, function (state, _ref2) {
  var store = _ref2.store;
  return Immutable["static"].merge(state, {
    store: store
  });
}), actions.setLocales, function (state, _ref3) {
  var locales = _ref3.locales;
  return Immutable["static"].merge(state, {
    locales: locales
  });
}), actions.setConfiguration, function (state, _ref4) {
  var configuration = _ref4.configuration;
  return Immutable["static"].merge(state, {
    configuration: configuration
  });
}), initialState);

//
// Selectors
//
var root = function root(state) {
  return state[key];
};
var lang = function lang(state) {
  return root(state).lang;
};
var store = function store(state) {
  return root(state).store;
};
var locales = function locales(state) {
  return root(state).locales;
};
var configuration = function configuration(state) {
  return root(state).configuration;
};
var getTranslator = createSelector([lang, store], function () {
  return function () {
    return i18next.t.apply(i18next, arguments);
  };
});
export var selectors = {
  lang: lang,
  store: store,
  locales: locales,
  configuration: configuration,
  getTranslator: getTranslator
};